export const getUserId = () => {

  let id = localStorage.getItem("omore_user_id");

  if (!id) {

    // Use randomUUID if available
    if (window.crypto && crypto.randomUUID) {
      id = crypto.randomUUID();
    } else {
      // fallback for old browsers / mobile
      id = "u_" + Math.random().toString(36).substring(2) + Date.now();
    }

    localStorage.setItem("omore_user_id", id);
  }

  return id;
};